import * as actionTypes from '../actions/actionTypes';

const initialState = {
  // AI Summary state
  insights: null,
  loading: false,
  error: null,
  generating: false,
  generationError: null,
  
  // AI models state
  models: [],
  modelsLoading: false,
  modelsError: null,
  selectedModelId: null,
  
  // Walkthrough state
  walkthrough: null,
  walkthroughLoading: false,
  walkthroughError: null
};

const aiReportSummaryReducer = (state = initialState, action) => {
  switch (action.type) {
    // AI Summary fetch actions
    case actionTypes.FETCH_AI_SUMMARY:
      return {
        ...state,
        error: null
      };
    case actionTypes.FETCH_AI_SUMMARY_LOADING:
      return {
        ...state,
        loading: true
      };
    case actionTypes.FETCH_AI_SUMMARY_SUCCESS:
      return {
        ...state,
        insights: action.summary,
        loading: false,
        error: null
      };
    case actionTypes.FETCH_AI_SUMMARY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case actionTypes.FETCH_AI_SUMMARY_DONE:
      return {
        ...state,
        loading: false
      };
      
    // AI Summary generation actions
    case actionTypes.GENERATE_AI_SUMMARY:
      return {
        ...state,
        generationError: null
      };
    case actionTypes.GENERATE_AI_SUMMARY_LOADING:
      return {
        ...state,
        generating: true
      };
    case actionTypes.GENERATE_AI_SUMMARY_SUCCESS:
      return {
        ...state,
        insights: action.summary,
        generating: false,
        generationError: null
      };
    case actionTypes.GENERATE_AI_SUMMARY_ERROR:
      return {
        ...state,
        generating: false,
        generationError: action.error
      };
    case actionTypes.GENERATE_AI_SUMMARY_DONE:
      return {
        ...state,
        generating: false
      };
      
    // AI Models actions
    case actionTypes.FETCH_AI_MODELS_LOADING:
      return {
        ...state,
        modelsLoading: true,
        modelsError: null
      };
    case actionTypes.FETCH_AI_MODELS_SUCCESS:
      return {
        ...state,
        models: action.models,
        modelsLoading: false,
        modelsError: null
      };
    case actionTypes.FETCH_AI_MODELS_ERROR:
      return {
        ...state,
        modelsLoading: false,
        modelsError: action.error
      };
    case actionTypes.FETCH_AI_MODELS_DONE:
      return {
        ...state,
        modelsLoading: false
      };
    case actionTypes.SET_SELECTED_AI_MODEL:
      return {
        ...state,
        selectedModelId: action.modelId
      };
      
    // AI Walkthrough actions
    case actionTypes.GENERATE_AI_WALKTHROUGH:
      return {
        ...state,
        walkthroughError: null
      };
    case actionTypes.GENERATE_AI_WALKTHROUGH_LOADING:
      return {
        ...state,
        walkthroughLoading: true
      };
    case actionTypes.GENERATE_AI_WALKTHROUGH_SUCCESS:
      return {
        ...state,
        walkthrough: action.walkthrough,
        walkthroughLoading: false,
        walkthroughError: null
      };
    case actionTypes.GENERATE_AI_WALKTHROUGH_ERROR:
      return {
        ...state,
        walkthroughLoading: false,
        walkthroughError: action.error
      };
    case actionTypes.GENERATE_AI_WALKTHROUGH_DONE:
      return {
        ...state,
        walkthroughLoading: false
      };
      
    default:
      return state;
  }
};

export default aiReportSummaryReducer;
